import React from "react";

import DropdownMenu from "./components/DropdownMenu";

const CommonHeader = (props) => {
    const {isMobile}=props
    return <DropdownMenu isMobile={isMobile}/>;
};

export default CommonHeader;
